import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import {
  IFilterComponent,
  SearchFilter,
} from "../../../infrastructure/iFilter-component";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FilterService } from "../../../services/filter.service";
import { FilterRecordService } from "../../../services/filter-record.service";
import { FilterCompleteService } from "../../../filter-complete/filter-complete";
import { ServiceFilter } from "../../../model/service-filter";
import { PracticeRegionFilter } from "../../../model/practice-region-filter";
import { SpecialityFilter } from "../../../model/speciality-filter";
import { AdmissionService } from "../../../services/admission.service";
import { PatientSearch } from "../../../model/patient/patient-search";
import { AuthService } from "../../../services/auth.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";

@Component({
  selector: "app-admission-reception-filter-component",
  templateUrl: "./admission-reception-filter.component.html",
  styleUrls: ["./admission-reception-filter.component.css"],
})
export class AdmissionReceptionFilterComponent
  implements IFilterComponent, OnInit
{
  serviceFilters: ServiceFilter[];
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;
  filterCompletePracticesRegion: FilterCompleteService<PracticeRegionFilter>;
  filterCompleteSpecialities: FilterCompleteService<SpecialityFilter>;
  canViewOtherCenters: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private admissionService: AdmissionService,
    private authService: AuthService,
    private filterRecordService: FilterRecordService,
    private motificationToastService: NotificationToastService
  ) {
    this.serviceFilters = [];
    this.form = this.formBuilder.group({
      Date: [new Date()],
      Service: [""],
      Specialty: [""],
      PracticeRegion: [""],
      Patient: [null],
      OrderByPatient: [false],
      ViewOtherCenters: [false],
    });

    this.filterCompleteSpecialities =
      new FilterCompleteService<SpecialityFilter>(
        [],
        this.form.controls.Specialty
      );
    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
      [],
      this.form.controls.Service
    );
    this.filterCompletePracticesRegion =
      new FilterCompleteService<PracticeRegionFilter>(
        [],
        this.form.controls.PracticeRegion
      );
  }

  get filteredSpecialitiesOptions() {
    return this.filterCompleteSpecialities
      ? this.filterCompleteSpecialities.filteredOptions
      : [];
  }
  get filteredServicesOptions() {
    return this.filterCompleteServices
      ? this.filterCompleteServices.filteredOptions
      : [];
  }
  get filteredPracticesRegionOptions() {
    return this.filterCompletePracticesRegion
      ? this.filterCompletePracticesRegion.filteredOptions
      : [];
  }
  get f() {
    return this.form.controls;
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push("Date");
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "AdmissionReceptionFilterComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "AdmissionReceptionFilterComponent",
      this.form
    );
  }

  async search(): Promise<any> {


    if (!this.form.controls.Date.value &&  !this.form.controls.Patient.value) {
      this.motificationToastService.error("Debe seleccionar una fecha o un paciente para realizar la busqueda.", 'Recepción');
      return [];
    } else {
      const serviceId = this.form.controls.Service.value
      ? (<ServiceFilter>this.form.controls.Service.value).Id
      : null;

    const serviceIds: number[] = [];

    if (serviceId) {
      serviceIds.push(serviceId);
    } else {
      this.serviceFilters.forEach((service) => {
        serviceIds.push(service.Id);
      });
    }

    const viewOtherCenter = this.form.controls.ViewOtherCenters.value
      ? true
      : false;
    return await this.admissionService.getAdmissionSearchItems(
      this.authService.getCompanyIds(),
      serviceIds,
      this.form.controls.OrderByPatient.value
      ? this.form.controls.OrderByPatient.value
      : false,
      this.form.controls.Date.value? <Date>this.form.controls.Date.value : null,
      this.form.controls.Patient.value
        ? (<PatientSearch>this.form.controls.Patient.value).Id
        : null,
      this.form.controls.PracticeRegion.value
        ? (<PracticeRegionFilter>this.form.controls.PracticeRegion.value).Id
        : null,
      this.form.controls.Specialty.value
        ? (<SpecialityFilter>this.form.controls.Specialty.value).Id
        : null,
      viewOtherCenter ? null : this.authService.getCenterId(),
      viewOtherCenter ? null : this.authService.getSectorId()
    );
    }


  }

  ngOnInit() {
    this.canViewOtherCenters = this.authService.canViewOtherCentersReception();
    this.authService.getSectorServices().then((services) => {
      this.serviceFilters = services;
      this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
        services,
        this.form.controls.Service
      );
    });

    this.filterService.getPracticesRegionFilter().then((practicesRegion) => {
      this.filterCompletePracticesRegion =
        new FilterCompleteService<PracticeRegionFilter>(
          practicesRegion,
          this.form.controls.PracticeRegion
        );
    });

    this.filterService.getSpecialtiesFilter().then((specialities) => {
      this.filterCompleteSpecialities =
        new FilterCompleteService<SpecialityFilter>(
          specialities,
          this.form.controls.Specialty
        );
    });
  }
}
